// extracted by mini-css-extract-plugin
export default {"wrapper":"ZXLfP8dNoea20QP9hlNe"};